import { ListCellIconAlignment, ListCellSecondaryTitleAlignment, CONTENT_ROW, CellStyles } from './constants.js';
import { InsetSize, Spacing, TextAlignment, Text, Colors, ThemingContext, IconType } from '@doordash/design-language';
import { ListCellContainer, ListCellContentContainer, SideContainer, MiddleContainer } from './styles.js';
import { ListCellSize, ListCellSide } from './types.js';
import ConditionalIconButton from './ConditionalIconButton.js';
import GridSeparator from './GridSeparator.js';
import React from 'react';
import Separator, { SeparatorType } from '@doordash/component-separator';
import get from 'lodash.get';
import { getPropsToForward } from '@doordash/utilities';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var stylesForSizeAndSelected = function stylesForSizeAndSelected(size, isToggled) {
  switch (size) {
    case ListCellSize.Small:
      return isToggled ? CellStyles.SmallToggled : CellStyles.Small;

    case ListCellSize.Large:
      return isToggled ? CellStyles.LargeToggled : CellStyles.Large;
  }
};

var getRootProps = function getRootProps(_ref) {
  var href = _ref.href,
      target = _ref.target,
      onClick = _ref.onClick,
      tag = _ref.tag,
      iconStart = _ref.iconStart,
      iconEnd = _ref.iconEnd;
  var rootProps = {};
  var rootTag = 'div';

  if (href) {
    rootTag = tag || 'a';
    rootProps = {
      href: href,
      target: target,
      onClick: onClick
    };
  } else if (onClick) {
    // If we have child buttons (like IconButtons)
    // we need to make sure that by default the
    // root container is not a button, and we'll
    // need to make sure that the button behavior
    // (like keyboard accessibility) is still
    // implemented as expected
    var hasChildButtons = iconStart && 'onClick' in iconStart && iconStart.onClick || iconEnd && 'onClick' in iconEnd && iconEnd.onClick;
    rootTag = tag || hasChildButtons ? 'div' : 'button';
    rootProps = {
      onClick: onClick,
      tabIndex: hasChildButtons ? 0 : undefined,
      role: hasChildButtons ? 'button' : undefined,
      onKeyDown: hasChildButtons ? function (event) {
        switch (event.key) {
          case ' ':
          case 'Enter':
            return event.target.click();

          default:
            return null;
        }
      } : undefined
    };
  }

  return {
    rootProps: rootProps,
    rootTag: rootTag
  };
};

var getColumnProps = function getColumnProps(_ref2) {
  var renderBeforeContent = _ref2.renderBeforeContent,
      renderAfterContent = _ref2.renderAfterContent,
      iconStart = _ref2.iconStart,
      iconEnd = _ref2.iconEnd,
      secondaryTitleStart = _ref2.secondaryTitleStart,
      secondaryTitleEnd = _ref2.secondaryTitleEnd;
  return {
    hasBeforeContent: !!renderBeforeContent ? 1 : 0,
    hasAfterContent: !!renderAfterContent ? 1 : 0,
    hasIconStart: iconStart && iconStart.type ? 1 : 0,
    hasIconEnd: iconEnd && iconEnd.type ? 1 : 0,
    hasSecondaryTitleStart: !!secondaryTitleStart ? 1 : 0,
    hasSecondaryTitleEnd: !!secondaryTitleEnd ? 1 : 0
  };
}; // Setup singleton for this check
// so that every ListCell doesn't have to
// check for this


var SUPPORTS_CSS_GRID_GLOBAL = undefined;

var ListCell = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(ListCell, _React$PureComponent);

  var _super = _createSuper(ListCell);

  function ListCell() {
    var _this;

    _classCallCheck(this, ListCell);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "cssGridSupportRequest", void 0);

    _defineProperty(_assertThisInitialized(_this), "state", {
      SUPPORTS_CSS_GRID: false
    });

    _defineProperty(_assertThisInitialized(_this), "contentRefs", {});

    _defineProperty(_assertThisInitialized(_this), "setContentRef", function (name) {
      return function (ref) {
        _this.contentRefs[name] = ref;
      };
    });

    return _this;
  }

  _createClass(ListCell, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      // Conditionally set this singleton and
      // if it's not currently defined at mount
      // set it in state to force a render
      if (typeof SUPPORTS_CSS_GRID_GLOBAL === 'undefined') {
        this.cssGridSupportRequest = requestAnimationFrame(function () {
          SUPPORTS_CSS_GRID_GLOBAL = typeof document.createElement('div').style.grid === 'string';

          _this2.setState({
            SUPPORTS_CSS_GRID: SUPPORTS_CSS_GRID_GLOBAL
          });
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (typeof this.cssGridSupportRequest !== 'undefined') {
        cancelAnimationFrame(this.cssGridSupportRequest);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$size = _this$props.size,
          size = _this$props$size === void 0 ? ListCellSize.Large : _this$props$size,
          _this$props$insetSize = _this$props.insetSize,
          insetSize = _this$props$insetSize === void 0 ? ListCell.InsetSizes.Small : _this$props$insetSize,
          _this$props$columnGap = _this$props.columnGapSize,
          columnGapSize = _this$props$columnGap === void 0 ? Spacing.Medium : _this$props$columnGap,
          _this$props$isTogglea = _this$props.isToggleable,
          isToggleable = _this$props$isTogglea === void 0 ? false : _this$props$isTogglea,
          _this$props$isSquishe = _this$props.isSquished,
          isSquished = _this$props$isSquishe === void 0 ? false : _this$props$isSquishe,
          _this$props$isSeparat = _this$props.isSeparatorVisible,
          isSeparatorVisible = _this$props$isSeparat === void 0 ? true : _this$props$isSeparat,
          _this$props$isSubtext = _this$props.isSubtextFirst,
          isSubtextFirst = _this$props$isSubtext === void 0 ? false : _this$props$isSubtext,
          _this$props$iconAlign = _this$props.iconAlignment,
          iconAlignment = _this$props$iconAlign === void 0 ? ListCellIconAlignment.Center : _this$props$iconAlign,
          _this$props$secondary = _this$props.secondaryTitleAlignment,
          secondaryTitleAlignment = _this$props$secondary === void 0 ? ListCellSecondaryTitleAlignment.FlexStart : _this$props$secondary,
          _this$props$shouldIns = _this$props.shouldInsetStartAtTitle,
          shouldInsetStartAtTitle = _this$props$shouldIns === void 0 ? false : _this$props$shouldIns,
          _this$props$shouldTru = _this$props.shouldTruncateSubContent,
          shouldTruncateSubContent = _this$props$shouldTru === void 0 ? false : _this$props$shouldTru,
          _this$props$titleMaxL = _this$props.titleMaxLines,
          titleMaxLines = _this$props$titleMaxL === void 0 ? 1 : _this$props$titleMaxL,
          _this$props$subtextMa = _this$props.subtextMaxLines,
          subtextMaxLines = _this$props$subtextMa === void 0 ? 3 : _this$props$subtextMa,
          _this$props$titleOver = _this$props.titleOverrides,
          titleOverrides = _this$props$titleOver === void 0 ? {} : _this$props$titleOver,
          _this$props$textAlign = _this$props.textAlign,
          textAlign = _this$props$textAlign === void 0 ? TextAlignment.Left : _this$props$textAlign,
          textVerticalAlignment = _this$props.textVerticalAlignment,
          _this$props$subtextOv = _this$props.subtextOverrides,
          subtextOverrides = _this$props$subtextOv === void 0 ? {} : _this$props$subtextOv,
          _this$props$secondary2 = _this$props.secondaryTitleOverrides,
          secondaryTitleOverrides = _this$props$secondary2 === void 0 ? {} : _this$props$secondary2,
          insetHorizontalSize = _this$props.insetHorizontalSize,
          insetVerticalSize = _this$props.insetVerticalSize,
          title = _this$props.title,
          subtext = _this$props.subtext,
          secondaryTitleStart = _this$props.secondaryTitleStart,
          secondaryTitleEnd = _this$props.secondaryTitleEnd,
          iconStart = _this$props.iconStart,
          iconEnd = _this$props.iconEnd,
          _this$props$separator = _this$props.separatorType,
          separatorType = _this$props$separator === void 0 ? SeparatorType.InsetBorder : _this$props$separator,
          isToggled = _this$props.isToggled,
          toggledColor = _this$props.toggledColor,
          onClick = _this$props.onClick,
          href = _this$props.href,
          tag = _this$props.tag,
          target = _this$props.target,
          focusStyleProps = _this$props.focusStyleProps,
          renderAboveContent = _this$props.renderAboveContent,
          renderBelowContent = _this$props.renderBelowContent,
          renderBeforeContent = _this$props.renderBeforeContent,
          renderAfterContent = _this$props.renderAfterContent,
          accessibilityLabel = _this$props.accessibilityLabel,
          accessibilityRole = _this$props.accessibilityRole,
          accessibilityDescribedBy = _this$props.accessibilityDescribedBy,
          accessibilityLabeledBy = _this$props.accessibilityLabeledBy,
          props = _objectWithoutProperties(_this$props, ["size", "insetSize", "columnGapSize", "isToggleable", "isSquished", "isSeparatorVisible", "isSubtextFirst", "iconAlignment", "secondaryTitleAlignment", "shouldInsetStartAtTitle", "shouldTruncateSubContent", "titleMaxLines", "subtextMaxLines", "titleOverrides", "textAlign", "textVerticalAlignment", "subtextOverrides", "secondaryTitleOverrides", "insetHorizontalSize", "insetVerticalSize", "title", "subtext", "secondaryTitleStart", "secondaryTitleEnd", "iconStart", "iconEnd", "separatorType", "isToggled", "toggledColor", "onClick", "href", "tag", "target", "focusStyleProps", "renderAboveContent", "renderBelowContent", "renderBeforeContent", "renderAfterContent", "accessibilityLabel", "accessibilityRole", "accessibilityDescribedBy", "accessibilityLabeledBy"]);

      var styles = stylesForSizeAndSelected(size, isToggled);
      var rootPropsAndTag = getRootProps({
        href: href,
        target: target,
        onClick: onClick,
        tag: tag,
        iconStart: iconStart,
        iconEnd: iconEnd
      });
      var columnProps = getColumnProps({
        renderBeforeContent: renderBeforeContent,
        renderAfterContent: renderAfterContent,
        iconStart: iconStart,
        iconEnd: iconEnd,
        secondaryTitleStart: secondaryTitleStart,
        secondaryTitleEnd: secondaryTitleEnd
      }); // Calculate the main content column by
      // using the derived column values from before

      var mainContentColumn = 1 + columnProps.hasIconStart + columnProps.hasBeforeContent + columnProps.hasSecondaryTitleStart; // Figure out what color we need to use for
      // toggled state and get it to the text
      // and color elements on the ListCell

      var colorOverride = isToggled ? toggledColor : undefined;
      var iconColor = isToggled ? toggledColor || get(this.context, 'Colors.ListCellIconToggledOn') : get(this.context, 'Colors.ListCellIconToggledOff'); // When `ListCell` is utilized in other packages like `Modal` or `NavBar`,
      // users have the option to center align the text.
      // - `renderEndIconContainer` is used to determine if space should be allotted
      // at the end of the `ListCell` for an icon OR to make space so the text is
      // truly center aligned.
      // - `renderEndIconSpacer` is used to determine if the icon should be visible
      // or not (in the case of a center-aligned title, there is not an end icon
      // so the space is empty to users)

      var renderEndIconContainer = !!columnProps.hasIconEnd || textAlign === TextAlignment.Center && !!columnProps.hasIconStart;
      var renderEndIconSpacer = !columnProps.hasIconEnd && textAlign === TextAlignment.Center;
      var subtextNode = /*#__PURE__*/React.createElement(Text, _extends({
        textAlign: textAlign,
        styles: styles.subtext,
        color: colorOverride,
        maxLines: subtextMaxLines
      }, subtextOverrides), subtext); // Check if we have set CSS grid
      // support on our singleton, otherwise
      // use the state that's being set on mount

      var SUPPORTS_CSS_GRID = typeof SUPPORTS_CSS_GRID_GLOBAL === 'undefined' ? this.state.SUPPORTS_CSS_GRID : SUPPORTS_CSS_GRID_GLOBAL; // Forward all data or aria props
      // to the root container

      var propsToForward = getPropsToForward({
        props: props,
        prefixesToForward: ['data-', 'aria-']
      });
      return /*#__PURE__*/React.createElement(ListCellContainer, _extends({
        theme: this.context,
        as: rootPropsAndTag.rootTag
      }, rootPropsAndTag.rootProps, {
        themeColors: {
          background: get(this.context, 'Colors.ListCellContainerBackgroundDefault', Colors.ListCellContainerBackgroundDefault // NOTE: these fallbacks are in place for the snapshot unit tests
          // due to Enzyme not supporting React's new `Context` API.
          // When Enzyme is updated to support, these redundant fallbacks
          // will be removed (as ThemingContext contains all properties for
          // Colors and BorderRadius)
          ),
          hovered: get(this.context, 'Colors.ListCellContainerBackgroundHovered', Colors.ListCellContainerBackgroundHovered),
          pressed: get(this.context, 'Colors.ListCellContainerBackgroundPressed', Colors.ListCellContainerBackgroundPressed)
        },
        focusStyleProps: focusStyleProps,
        role: accessibilityRole,
        "aria-label": accessibilityLabel,
        "aria-labelledby": accessibilityLabeledBy,
        "aria-describedby": accessibilityDescribedBy,
        "aria-checked": isToggleable || typeof isToggled === 'boolean' ? isToggled : undefined
      }, propsToForward), /*#__PURE__*/React.createElement(ListCellContentContainer, _extends({
        isSquished: isSquished
      }, columnProps, {
        insetSize: insetSize,
        insetHorizontalSize: insetHorizontalSize,
        insetVerticalSize: insetVerticalSize,
        columnGapSize: columnGapSize,
        shouldTruncateSubContent: shouldTruncateSubContent
      }), renderBeforeContent && /*#__PURE__*/React.createElement("div", {
        style: {
          gridRow: CONTENT_ROW,
          gridColumn: 1
        },
        ref: this.setContentRef('before')
      }, renderBeforeContent()), iconStart && /*#__PURE__*/React.createElement(ConditionalIconButton, _extends({
        side: ListCellSide.Start,
        iconAlignment: iconAlignment,
        sharedColor: iconColor,
        iconProps: iconStart
      }, columnProps)), secondaryTitleStart && /*#__PURE__*/React.createElement(SideContainer, _extends({
        side: ListCellSide.Start,
        alignment: secondaryTitleAlignment
      }, columnProps), /*#__PURE__*/React.createElement(Text, _extends({
        textAlign: textAlign,
        styles: styles.secondaryTitle,
        color: colorOverride
      }, secondaryTitleOverrides), secondaryTitleStart)), renderAboveContent && SUPPORTS_CSS_GRID && /*#__PURE__*/React.createElement("div", {
        style: {
          gridRow: CONTENT_ROW - 1,
          gridColumn: mainContentColumn
        },
        ref: this.setContentRef('above')
      }, renderAboveContent()), /*#__PURE__*/React.createElement(MiddleContainer, _extends({}, columnProps, {
        alignment: textVerticalAlignment
      }), renderAboveContent && !SUPPORTS_CSS_GRID && /*#__PURE__*/React.createElement("div", null, renderAboveContent()), subtext && isSubtextFirst && subtextNode, /*#__PURE__*/React.createElement(Text, _extends({
        textAlign: textAlign,
        styles: styles.title,
        color: colorOverride,
        maxLines: titleMaxLines
      }, titleOverrides), title), subtext && !isSubtextFirst && subtextNode, renderBelowContent && !SUPPORTS_CSS_GRID && /*#__PURE__*/React.createElement("div", null, renderBelowContent())), renderBelowContent && SUPPORTS_CSS_GRID && /*#__PURE__*/React.createElement("div", {
        style: {
          gridRow: CONTENT_ROW + 1,
          gridColumn: mainContentColumn
        },
        ref: this.setContentRef('below')
      }, renderBelowContent()), secondaryTitleEnd && /*#__PURE__*/React.createElement(SideContainer, _extends({
        side: ListCellSide.End,
        alignment: secondaryTitleAlignment
      }, columnProps), /*#__PURE__*/React.createElement(Text, _extends({
        textAlign: textAlign,
        styles: styles.secondaryTitle,
        color: colorOverride
      }, secondaryTitleOverrides), secondaryTitleEnd)), renderEndIconContainer && iconEnd && /*#__PURE__*/React.createElement(ConditionalIconButton, _extends({
        renderIconSpacer: renderEndIconSpacer,
        iconAlignment: iconAlignment,
        side: ListCellSide.End,
        sharedColor: iconColor,
        iconProps: iconEnd
      }, columnProps)), renderAfterContent && /*#__PURE__*/React.createElement("div", {
        style: {
          gridRow: CONTENT_ROW,
          gridColumn: mainContentColumn + 1 + columnProps.hasIconEnd + columnProps.hasSecondaryTitleEnd
        },
        ref: this.setContentRef('after')
      }, renderAfterContent()), isSeparatorVisible && separatorType && SUPPORTS_CSS_GRID && /*#__PURE__*/React.createElement(GridSeparator, {
        shouldInsetStartAtTitle: shouldInsetStartAtTitle,
        type: separatorType,
        isSquished: isSquished && typeof insetVerticalSize === 'undefined',
        insetHorizontalSize: typeof insetHorizontalSize !== 'undefined' ? insetHorizontalSize : insetSize,
        insetVerticalSize: typeof insetVerticalSize !== 'undefined' ? insetVerticalSize : insetSize,
        middleColumn: mainContentColumn
      })), isSeparatorVisible && separatorType && !SUPPORTS_CSS_GRID && /*#__PURE__*/React.createElement(Separator, {
        type: separatorType
      }));
    }
  }]);

  return ListCell;
}(React.PureComponent);

_defineProperty(ListCell, "contextType", ThemingContext);

_defineProperty(ListCell, "Sizes", ListCellSize);

_defineProperty(ListCell, "IconTypes", IconType);

_defineProperty(ListCell, "InsetSizes", InsetSize);

_defineProperty(ListCell, "SeparatorTypes", SeparatorType);

_defineProperty(ListCell, "Alignment", ListCellIconAlignment);

_defineProperty(ListCell, "defaultProps", {
  size: ListCellSize.Large,
  insetSize: InsetSize.Small,
  separatorType: SeparatorType.InsetBorder,
  columnGapSize: Spacing.Medium,
  isToggleable: false,
  isSquished: false,
  isSeparatorVisible: true,
  isSubtextFirst: false,
  iconAlignment: ListCellIconAlignment.Center,
  secondaryTitleAlignment: ListCellSecondaryTitleAlignment.FlexStart,
  shouldInsetStartAtTitle: false,
  shouldTruncateSubContent: false,
  titleMaxLines: 1,
  subtextMaxLines: 3,
  titleOverrides: {},
  textAlign: TextAlignment.Left,
  subtextOverrides: {},
  secondaryTitleOverrides: {}
});

export { ListCell as default };
